import { render, staticRenderFns } from "./AttemptsSubject.vue?vue&type=template&id=733091e6"
import script from "./AttemptsSubject.vue?vue&type=script&lang=js"
export * from "./AttemptsSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports